module.exports = __webpack_public_path__ + "static/media/thadeuro_thee_dirgha.c8ad9b45.ogg";